import React, { createContext, useContext } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ user, setUser, children }) => {
    return (
        <AuthContext.Provider value={{ user, setUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

